module.exports = ".app-edit {\n  margin-top: 100px;\n}\ninput.ng-invalid.ng-touched, textarea.ng-invalid.ng-touched {\n  border: 1px solid red;\n}\n"